var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 11.6562H13.3438V7.64844C13.3438 7.53242 13.2488 7.4375 13.1328 7.4375H11.8672C11.7512 7.4375 11.6562 7.53242 11.6562 7.64844V11.6562H7.64844C7.53242 11.6562 7.4375 11.7512 7.4375 11.8672V13.1328C7.4375 13.2488 7.53242 13.3438 7.64844 13.3438H11.6562V17.3516C11.6562 17.4676 11.7512 17.5625 11.8672 17.5625H13.1328C13.2488 17.5625 13.3438 17.4676 13.3438 17.3516V13.3438H17.3516C17.4676 13.3438 17.5625 13.2488 17.5625 13.1328V11.8672C17.5625 11.7512 17.4676 11.6562 17.3516 11.6562Z",
    fill: "#396FC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.6875C5.97676 0.6875 0.6875 5.97676 0.6875 12.5C0.6875 19.0232 5.97676 24.3125 12.5 24.3125C19.0232 24.3125 24.3125 19.0232 24.3125 12.5C24.3125 5.97676 19.0232 0.6875 12.5 0.6875ZM12.5 22.3086C7.08418 22.3086 2.69141 17.9158 2.69141 12.5C2.69141 7.08418 7.08418 2.69141 12.5 2.69141C17.9158 2.69141 22.3086 7.08418 22.3086 12.5C22.3086 17.9158 17.9158 22.3086 12.5 22.3086Z",
    fill: "#396FC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIcon);
export default __webpack_public_path__ + "static/media/circle_plus_icon.4f4db68eadb3b9b8297af7033d748f4c.svg";
export { ForwardRef as ReactComponent };